<template>
  <v-card style="box-shadow:none!important;border: 1px solid #EDEFFB !important;">
    <v-card-text>
     
      <v-row class="mt-4">
        <v-col cols="5">
          <span class="h5 font-weight-bold black--text">{{ $t('AddFamilyMemberDialog.FinancialPOA(FPOA)') }}:</span>
        </v-col>
        <v-col cols="7">
          <v-checkbox v-model="isFinancialEPOAModel" :disabled="disabled" />
        </v-col>
      </v-row>
      <v-row class="mt-4">
        <v-col cols="5">
          <span class="h5 font-weight-bold black--text">{{ $t('AddFamilyMemberDialog.WelfarePOA(WPOA)') }}:</span>
        </v-col>
        <v-col cols="7">
          <v-checkbox v-model="isWelfarePOAModel" :disabled="disabled" />
        </v-col>
      </v-row>
      <v-row class="mt-4">
        <v-col cols="5">
          <span class="h5 font-weight-bold black--text">{{ $t('AddFamilyMemberDialog.EnduringPOA(EPOA)') }}:</span>
        </v-col>
        <v-col cols="7">
          <v-checkbox v-model="isEnduringPOAModel" :disabled="disabled" />
        </v-col>
      </v-row>
      
      <v-row>
        <v-col cols="5">
          <span class="h5 font-weight-bold black--text">{{ $t('GeneralTranslations.Resident') }}:</span>
        </v-col>
        <v-col cols="5">
          <v-avatar size="42" class="ml-4">
            <img :src="resident.imageUrl" />
          </v-avatar>
          <span class="ml-3 h6">{{ resident.name }}</span>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
          <router-link :to="`/residents/${resident.id}`">
            <v-btn uppercase text color="primary" class="font-weight-bold">
              {{ $t('GeneralTranslations.View') }}
            </v-btn>
          </router-link>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="5">
          <span class="h5 font-weight-bold black--text">{{ $t('ResidentCard.RelationshipToResident') }}:</span>
        </v-col>
        <v-col cols="7">
          <span class="ml-4 h6">{{ relationshipToResident?.length ?  $t(`RelationshipTypes.${relationshipToResident}`) : ''}}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="5">
          <span class="h5 font-weight-bold black--text">{{ $t('GeneralTranslations.Room') }}:</span>
        </v-col>
        <v-col cols="7">
          <span class="ml-4 h6">{{ resident.wingName }}, {{ resident.roomName }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="5">
          <span class="h5 font-weight-bold black--text">{{ $t('GeneralTranslations.DOB') }}:</span>
        </v-col>
        <v-col cols="7">
          <span class="ml-4 h6">{{ dateOfBirthDisplay }}</span>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="5">
          <span class="h5 font-weight-bold black--text">{{ $t('GeneralTranslations.Status') }}:</span>
        </v-col>
        <v-col cols="7">
          <span v-if="resident.status === 'Departed'" class="ml-4 h6 departed">{{  $t('ResidentStatus.Departed') }}</span>
          <span v-else class="ml-4 h6">{{ $t(`ResidentStatus.${resident.status.replace(' ','')}`)}} </span>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import moment from 'moment';
export default {
  props: {
    resident: {
      type: Object,
      required: true,
    },
    isEnduringPOA: {
      type: Boolean,
      default: false,
    },
    isFinancialEPOA: {
      type: Boolean,
      default: false,
    },
    isWelfarePOA: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    relationshipToResident: {
      type: String,
      default: ""
    },
    isNextOfKin: {
      type: Boolean,
      default: false,
    },
  },
  data(){
    return{ dateOfBirthDisplay: ''} 
  },
  computed: {
    facility() {
      return this.$store.state.facilityModule.selectedFacility;
    },
    isFinancialEPOAModel: {
      get() {
        return this.isFinancialEPOA;
      },
      set(value) {
        this.$emit('change', {
          isFinancialEPOA: {
            id: this.resident.id,
            status: value,
          }
        });
      },
    },
    isEnduringPOAModel: {
      get() {
        return this.isEnduringPOA;
      },
      set(value) {
        this.$emit('change', {
          isEnduringPOA: {
            id: this.resident.id,
            status: value,
          }
        });
      },
    },
    isWelfarePOAModel: {
      get() {
        return this.isWelfarePOA;
      },
      set(value) {
        this.$emit('change', {
          isWelfarePOA: {
            id: this.resident.id,
            status: value,
          }
        });
      },
    },
    isNextOfKinComputed: {
      get() {
        return this.isNextOfKin;
      },
      set(value) {
        this.$emit('update:isNextOfKin', {
          id: this.resident.id,
          isNextOfKin: value,
        });
      },
    },
  },
  created(){
     this.dateOfBirthDisplay = moment(new Date(this.resident.dateOfBirth.seconds * 1000)).format(this.facility.dateFormat)
  }
};
</script>

<style scoped>
.departed {
  color: red;
}
</style>
